import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { IconButton } from '@material-ui/core'

import { EndPollIcon } from 'app/components/icons'

import { SUBMIT } from 'app/constants/button'
import PrimaryTooltip from 'app/componentV4/Tooltip/PrimaryTooltip'
import SubmitDialog from 'app/componentV4/Dialog/SubmitDialog'

const EndPoll = (props) => {
  const { onSubmit, onDialog } = props
  const { formatMessage } = useIntl()

  const [isOpen, setIsOpen] = useState(false)

  const handleOpen = () => {
    setIsOpen(true)
    onDialog(true)
  }

  const handleClose = () => {
    setIsOpen(false)
    onDialog(false)
  }

  return (
    <>
      <PrimaryTooltip
        title={formatMessage({
          id: 'timeline.dialog.submit.cancel.poll',
        })}
      >
        <IconButton
          aria-label="Delete Button Icon"
          size="small"
          className="text-red-500"
          onClick={() => {
            handleOpen()
          }}
        >
          <EndPollIcon classes="h-20 w-20" />
        </IconButton>
      </PrimaryTooltip>
      <SubmitDialog
        id="dialog-cancel-poll-timeline"
        open={isOpen}
        type={SUBMIT}
        title={formatMessage({
          id: 'timeline.dialog.title.cancel.poll',
        })}
        description={formatMessage({
          id: 'timeline.dialog.description.cancel.poll',
        })}
        submitText={formatMessage({
          id: 'timeline.dialog.submit.cancel.poll',
        })}
        onSubmit={async () => {
          onSubmit()
          handleClose()
        }}
        closeText={formatMessage({
          id: 'text.close',
        })}
        onClose={() => handleClose()}
      />
    </>
  )
}

EndPoll.propTypes = {
  className: PropTypes.string,
  onSubmit: PropTypes.func,
  onDialog: PropTypes.func,
}

export default EndPoll
